import React from "react";
import ResponsiveNav from "@rsuite/responsive-nav";

import "./SmartTabsStyle.css";
import "./BottomDrawerStyle.css";

import { FaInfo } from "react-icons/fa";
import { FaWrench } from "react-icons/fa";
//import { FaRegBuilding } from "react-icons/fa"; // Not used at the moment, as the free rooms tab is a leftover from past requirements
import { FaRegFolderOpen } from "react-icons/fa";

import AboutTab from "./about-tab/AboutTab";
import TroubleReportsTab from "./trouble-reports-tab/TroubleReportsTab";
//import FreeRoomsTab from "./free-rooms-tab/FreeRoomsTab"; // Not used at the moment, as the free rooms tab is a leftover from past requirements

const SmartTabs = ({ style, allRooms, troubleReportData }) => {
  const [tabsKey, setTabsKey] = React.useState("");
  const [aboutOpen, setAboutOpen] = React.useState(false);
  const [faultReportsOpen, setFaultReportsOpen] = React.useState(false);
  //const [freeRoomsOpen, setFreeRoomsOpen] = React.useState(false); // Not used at the moment, as the free rooms tab is a leftover from past requirements

  return (
    <div style={style} className="smart-tabs-container">
      {/* Tab Container */}
      {/* A click on eighter child (tab) will open its equivalent bottom drawer. */}
      <ResponsiveNav
        activeKey={tabsKey}
        onSelect={(eventKey) => setTabsKey(eventKey + "")}
        appearance="subtle"
        justified={true}
        moreProps={{
          icon: <FaRegFolderOpen />,
          noCaret: true,
          placement: "topStart",
        }}
        moreText={"Weiteres"}
        className="smart-tabs"
      >
        {/* About tab wording */}
        <ResponsiveNav.Item
          key={"A"}
          eventKey={"A"}
          icon={<FaInfo />}
          onSelect={() => setAboutOpen(true)}
        >
          Über loc.ur.de
        </ResponsiveNav.Item>

        {/* Trouble reports tab wording */}
        <ResponsiveNav.Item
          key={"B"}
          eventKey={"B"}
          icon={<FaWrench />}
          onSelect={() => setFaultReportsOpen(true)}
        >
          UR Störungsmeldungen
        </ResponsiveNav.Item>

        {/* Free nearby rooms section - currently disabled due from past requirements */}
        {/*
        <ResponsiveNav.Item
          key={"C"}
          eventKey={"C"}
          icon={<FaRegBuilding />}
          onSelect={() => setFreeRoomsOpen(true)}
        >
          Freie Räume
        </ResponsiveNav.Item>
        */}
      </ResponsiveNav>

      {/* Bottom drawer for the about tab */}
      <AboutTab
        allRooms={allRooms}
        openVar={aboutOpen}
        openMethod={setAboutOpen}
      />

      {/* Bottom drawer for the trouble reports tab */}
      <TroubleReportsTab
        troubleReportData={troubleReportData}
        openVar={faultReportsOpen}
        openMethod={setFaultReportsOpen}
      />

      {/* Bottom drawer for the free rooms tab - currently disabled due from past requirements */}
      {/*<FreeRoomsTab openVar={freeRoomsOpen} openMethod={setFreeRoomsOpen} />*/}
    </div>
  );
};

/* Default empty style props to handle fallback for missing prop definitions */
SmartTabs.defaultProps = {
  style: {},
};

export default SmartTabs;
